function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import VideoPlayer from "./VideoPlayer";
const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    //        backgroundColor: "#333",
    //        color: "white",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
}));

const VideoPreview = (_ref) => {
  let className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["className"]);

  const classes = useStyles();
  return React.createElement("figure", {
    className: className || classes.root
  }, React.createElement(VideoPlayer, props));
};

export default VideoPreview;